module.exports = __webpack_public_path__ + "img/sofort.2b6fdfe.svg";